import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class WutonghuiPic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { imageUrl, url },
        } = this.props;

        return (
            <div className={styles.pic_box}>
                <a href={url} target="_blank">
                    <img src={imageUrl} width="300" height="250" />
                </a>
            </div>
        );
    }
}

export default errorBoundary(WutonghuiPic);
